<kilowant-header [isSeller]="true" title="Licensing Fees"></kilowant-header>
<div class="form seller">
  <div class="card mt-20">
    <div class="body">
      <h2>The following table contains the fees sturcure</h2>
      <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows matSortActive="UtilityName" matSortDisableClear matSortDirection="asc" class="offer-summmary-table">
        <ng-container matColumnDef="#">
          <th mat-header-cell *matHeaderCellDef>#</th>
          <td mat-cell *matCellDef="let element; let i = dataIndex">{{i+1}}</td>
        </ng-container>
        <ng-container matColumnDef="Utilities">
          <th mat-header-cell *matHeaderCellDef>Utilities</th>
          <td mat-cell *matCellDef="let element" class="short-list-view">
            @if (element.utilities.length > 0) {
              <span>{{element.utilities[0].name}}</span>
              @if (element.utilities.length > 1) {
                <span>{{element.utilities[1].name}}</span>
              }
              @if (element.utilities.length > 2) {
                <a class="viewMore" (click)="expandedElement = expandedElement === element ? null : element">More..</a>
              }
            }
          </td>
          <ng-container matColumnDef="expandedDetail">
            <td mat-cell *matCellDef="let element" class="short-list-view" [attr.colspan]="displayedColumns.length">
              <div class="example-element-detail" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
                <div class="expanded-block">
                  <i></i>
                  <b>Utilities:</b><br />
                  @for (utility of element.utilities; track utility; let x = $index) {
                    <span>{{utility.name}}</span>
                    }<br />
                    <b>Load Zones:</b><br />
                    @for (loadZone of element.loadZones; track loadZone; let x = $index) {
                      <span>{{loadZone.name}}</span>
                      }<br />
                      <b>Rate Classes:</b><br />
                      @for (rateclass of element.rateClasses; track rateclass; let x = $index) {
                        <span>{{rateclass.name}}</span>
                      }
                    </div>
                  </div>
                </td>
              </ng-container>
            </ng-container>
            <ng-container matColumnDef="LoadZones">
              <th mat-header-cell *matHeaderCellDef>Load Zones</th>
              <td mat-cell *matCellDef="let element" class="short-list-view">
                @if (element.loadZones.length > 0) {
                  <span>{{element.loadZones[0].name}}</span>
                  @if (element.loadZones.length > 1) {
                    <span>{{element.loadZones[1].name}}</span>
                  }
                  @if (element.loadZones.length > 2) {
                    <a class="viewMore" (click)="expandedElement = expandedElement === element ? null : element">More..</a>
                  }
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="RateClasses">
              <th mat-header-cell *matHeaderCellDef>Rate Classes</th>
              <td mat-cell *matCellDef="let element" class="short-list-view">
                @if (element.rateClasses.length > 0) {
                  <span>{{element.rateClasses[0].name}}</span>
                  @if (element.rateClasses.length > 1) {
                    <span>{{element.rateClasses[1].name}}</span>
                  }
                  @if (element.rateClasses.length > 2) {
                    <a class="viewMore" (click)="expandedElement = expandedElement === element ? null : element">More..</a>
                  }
                }
              </td>
            </ng-container>
            <ng-container matColumnDef="StartDate">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Start Date</th>
              <td mat-cell *matCellDef="let element">  {{(element.startDate==null)?"-":element.startDate | date:'short'}} EST </td>
            </ng-container>
            <ng-container matColumnDef="ValidUntil">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>Valid Until</th>
              <td mat-cell *matCellDef="let element">  {{(element.validUntil==null)?"-":element.validUntil | date:'short'}} {{(element.validUntil==null)?"":' EST'}} </td>
            </ng-container>
            <ng-container matColumnDef="Fee">
              <th mat-header-cell *matHeaderCellDef>Fee</th>
              <td mat-cell *matCellDef="let element">{{element.fee | currency:'USD':'symbol':'1.5-5'}}/kWh</td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let element; columns: displayedColumns;" class="example-element-row" [class.example-expanded-row]="expandedElement === element"></tr>
            <tr mat-row *matRowDef="let row; columns: ['expandedDetail']" class="example-detail-row"></tr>
          </table>
          <mat-paginator class="b-none" [hidePageSize]="true" showFirstLastButtons [pageSize]="RECS_PER_PAGE" aria-label="Select page"></mat-paginator>
        </div>
      </div>
    </div>
